import { createFileRoute, Outlet, useNavigate, useRouterState } from '@tanstack/react-router';
import { Home, MessageCircle, Search, User } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { TabBar } from '@nokowazzi/ui';
import { useUnreadTotal } from '../features/chat/useUnreadTotal';

export const Route = createFileRoute('/_tabs')({
  component: TabsLayout,
});

const TAB_ROUTES = {
  home: '/',
  sourcing: '/sourcing',
  chat: '/chat',
  my: '/my',
} as const;

type TabKey = keyof typeof TAB_ROUTES;

function TabsLayout() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const unreadTotal = useUnreadTotal();

  const activeKey: TabKey =
    pathname.startsWith('/sourcing') ? 'sourcing'
    : pathname.startsWith('/chat') ? 'chat'
    : pathname.startsWith('/my') ? 'my'
    : 'home';

  return (
    <div className="flex min-h-dvh flex-col">
      <main className="flex-1 pb-[calc(56px+var(--safe-bottom))]">
        <Outlet />
      </main>
      <TabBar
        items={[
          { key: 'home', label: t('tabs.home'), icon: <Home size={24} /> },
          { key: 'sourcing', label: t('tabs.sourcing'), icon: <Search size={24} /> },
          {
            key: 'chat',
            label: t('tabs.chat'),
            icon: <MessageCircle size={24} />,
            badgeCount: unreadTotal,
          },
          { key: 'my', label: t('tabs.my'), icon: <User size={24} /> },
        ]}
        activeKey={activeKey}
        onChange={(key) => void navigate({ to: TAB_ROUTES[key as TabKey] })}
      />
    </div>
  );
}
